import { BareActionContext } from 'vuex-typex'
import { RootState } from '@/store'
import mainStore from '@/store/main/main-store';
import { FeedState } from '@/store/feed/state';
import feedStore from '@/store/feed/feed-store';

export default async function setFeedPage(context: BareActionContext<FeedState, RootState>, payload: {feedType: string, page: string, forceLogin: boolean, id?: string|null|undefined, uid?: string|null|undefined})
{
  mainStore.dispatchSetCurrentPage({component: 'feed', page: payload.page, id: payload.id, uid: payload.uid, isAuthRequired: false, forceLogin: payload.forceLogin})
  
  feedStore.commitSetFeed({feedType: payload.feedType, feedId: payload.id, feedUserId: payload.uid})

  return
}
